import { useNavigate } from "react-router-dom";
const PrivacyPolicy = () => {
  const router = useNavigate();

  return (
    <div className="container mx-auto px-4 py-12">
      <button
        onClick={() => router('/')}
        className="mb-8 inline-flex items-center text-primary font-medium hover:underline"
      >
        ← Back
      </button>
      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      <div className="prose max-w-none">
        <p>Last updated: March 2024</p>

        <h2 className="text-2xl font-semibold mt-6 mb-4">1. Information We Collect</h2>
        <p>When you visit our website or use our services, we may collect certain information about you, including:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Personal information (name, email address, phone number)</li>
          <li>Child's information (name, age)</li>
          <li>Location information</li>
          <li>Device and browser information</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-4">2. How We Use Your Information</h2>
        <p>We use the collected information for various purposes:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>To provide and maintain our services</li>
          <li>To notify you about changes to our services</li>
          <li>To provide customer support</li>
          <li>To gather analysis or valuable information to improve our services</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-4">3. Data Security</h2>
        <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>

        <h2 className="text-2xl font-semibold mt-6 mb-4">4. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Email: info@tumblegym.in</li>
          <li>Phone: +91 7019271281</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
